import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Figure } from "react-bootstrap";
import { IoMdOpen } from "react-icons/io";
import * as UTILS from "../helpers/Utility";

const OrderDocument = ({ url, formHandler }) => (
  <>
    <div className="document">
      <a href={url}>
        <b>
          Order <IoMdOpen />
        </b>
        <br />
        {UTILS.FileNameFromUrl(url)}
      </a>
    </div>
    <a className={'btn btn-default'} onClick={(el) => {
      const formData = new FormData();
      formData.append("task[delete_order_document]", true);
      formHandler(formData);
    }}>
      <i className={'fa fa-times'} />
      Delete Document
    </a>
  </>
);

export default OrderDocument;
